module.exports = __webpack_public_path__ + "static/img/id.e8823835.svg";